export default "__VITE_ASSET__CQPTi2G8__"